<template>
    <div class="vx-card p-6">

        <vx-card card-border class="mb-4" title="Datos de la cuenta" title-color="dark" collapseAction>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    <div>
                        <span>Username</span>
                    </div>
                    <div>
                        <vs-input name="username" class="w-full" v-model="usuario.username" disabled />
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    <div>
                        <span>DNI</span>
                    </div>
                    <div>
                        <vs-input name="dni" class="w-full" v-model="usuario.dni" disabled />
                    </div>
                </div>
            </div>
        </vx-card>

        <vx-card card-border class="mb-4" title="Datos personales" title-color="dark" collapseAction>
          <div class="vx-row mb-2">
            <div class="vx-col sm:w-1/2 w-full">
              <div>
                <span class="campoObligatorio">Nombre *</span>
              </div>
              <div>
                <vs-input class="w-full" data-vv-as="NOMBRE" v-model="usuario.nombre" v-validate="'required'" name="nombre" />
                <span class="text-danger text-sm"  v-show="errors.has('nombre')">{{ errors.first('nombre') }}</span>
              </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <div>
                <span class="campoObligatorio">Apellidos *</span>
              </div>
              <div>
                <vs-input class="w-full" data-vv-as="APELLIDOS" v-model="usuario.apellidos" v-validate="'required'" name="apellidos" />
                <span class="text-danger text-sm"  v-show="errors.has('apellidos')">{{ errors.first('apellidos') }}</span>
              </div>
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col sm:w-1/2 w-full">
              <div>
                <span class="campoObligatorio">E-mail *</span>
              </div>
              <div>
                <vs-input class="w-full" data-vv-as="EMAIL" v-model="usuario.email" type="email" v-validate="'required|email'" name="email" />
                <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
              </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <div>
                <span class="campoObligatorio">Teléfono de contacto *</span>
              </div>
              <div>
                <vs-input class="w-full" data-vv-as="TELÉFONO DE CONTACTO" v-validate="{ required: true, regex: /^\+?([0-9]+)$/, min: 9 }" 
                  name="telefono" v-model="usuario.telefono"/>
                <span class="text-danger text-sm"  v-show="errors.has('telefono')">{{ errors.first('telefono') }}</span>
              </div>
            </div>
          </div>
        </vx-card>

        <vx-card card-border class="mb-6" title="Datos del perfil" title-color="dark" collapseAction>
          <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <vx-card card-border>
                <div>
                  <feather-icon svgClasses="w-6 h-6" icon="KeyIcon" class="mr-2" />
                  <span class="leading-none">Cambiar contraseña</span>
                </div>
                <vs-divider />
                <div class="vx-col w-full mb-4">
                  <div class="w-full flex justify-center">
                    <vs-button color="success" type="border" class="mt-5" @click="popupCambioContrasinal=true">Cambiar contraseña</vs-button>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </vx-card>

        <!-- POPUP CAMBIO CONTRASINAL -->
        <div>
          <vs-popup title="Cambiar contraseña" :active.sync="popupCambioContrasinal">
            <div class="vx-col w-full mb-4">
                <div>
                    <span>Contraseña actual</span>
                </div>
                <div>
                    <vs-input type="password" class="w-full" data-vv-as="CONTRASEÑA ACTUAL" v-model="oldPassword" v-validate="'required'" name="oldPassword" />
                    <span class="text-danger text-sm"  v-show="errors.has('oldPassword')">{{ errors.first('oldPassword') }}</span>
                </div>
            </div>
            <vs-divider ></vs-divider>
            <div class="vx-col w-full mb-4">
                <div>
                    <span>Nueva contraseña</span>
                </div>
                <div>
                    <vs-input type="password" class="w-full" data-vv-as="NUEVA CONTRASEÑA" v-model="newPassword1" v-validate="'required'" name="newPassword1"  ref="password"/>
                    <span class="text-danger text-sm"  v-show="errors.has('newPassword1')">{{ errors.first('newPassword1') }}</span>
                </div>
            </div>
            <div class="vx-col w-full mb-2">
                <div>
                    <span>Confirmar nueva contraseña</span>
                </div>
                <div>
                    <vs-input type="password" class="w-full" data-vv-as="CONFIRMAR NUEVA CONTRASEÑA" v-model="newPassword2" v-validate="'required|confirmed:password'" name="newPassword2" />
                    <span class="text-danger text-sm"  v-show="errors.has('newPassword2')">{{ errors.first('newPassword2') }}</span>
                </div>
            </div>
            <vs-divider ></vs-divider>
            <div class="vx-row">
                <div class="vx-col w-full flex justify-end">
                <vs-button class="mr-4 mb-2" @click="verificarUsuarioAutenticado" :disabled="!validatePasswords">Guardar</vs-button>
                <vs-button color="warning" type="border" class="mb-2" @click="cerrarPopup()">Cancelar</vs-button>
                </div>
            </div>
          </vs-popup>
        </div>
        
        <div class="vx-row">
            <div class="vx-col w-full flex justify-end">
            <vs-button class="mr-4 mb-2" @click="guardar" :disabled="!validateForm">Guardar</vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="cancelar()">Cancelar</vs-button>
            </div>
        </div>

    </div>
</template>


<script>
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  data () {
    return {
      usuario: {
        apellidos: '',
        dni: '',
        email: '',
        empresa: '/api/empresas/1',
        nombre: '',
        username: ''
      },
      oldPassword: '',
      newPassword1: '',
      newPassword2: '',
      popupCambioContrasinal: false
    }
  },
  computed: {
    validateForm () {
      if (this.errors.any() 
        || this.usuario.nombre === undefined || this.usuario.nombre === null 
        || this.usuario.apellidos === undefined || this.usuario.apellidos === null 
        || this.usuario.email === undefined  || this.usuario.email === null
        || this.usuario.telefono === undefined  || this.usuario.telefono === null
        || this.popupCambioContrasinal === true) {
        return false
      } else {
        return true
      }
    },
    validatePasswords () {
      if (this.errors.any() || this.oldPassword === '' || this.newPassword1 === '' || this.newPassword2 === '') {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    guardar () {
      if (!this.validateForm) return
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      delete this.usuario.empresa
      delete this.usuario.dni
      delete this.usuario.username
      delete this.usuario.password
      delete this.usuario.roles
      this.$store.dispatch('userManagement/updateUser', this.usuario)
        .then((response)   => { 
          const nombreCompleto = `${response.data.nombre  } ${  response.data.apellidos}`
          this.$store.dispatch('updateUserInfo', {displayName: nombreCompleto})
          this.showUpdateSuccess() 
        })
        .catch(error => { 
          this.showUpdateError(error) 
        })
    },
    showUpdateSuccess () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'PERFIL ACTUALIZADO',
        text: 'Los datos personales y del perfil han sido actualizados correctamente.'
      })
      this.$router.push({name:'inicio'})
    },
    showUpdateError (error) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'ERROR',
        text: `Los datos personales y del perfil no han podido ser actualizados. ${  error}`
      })
    },
    verificarUsuarioAutenticado () {
      if (!this.validatePasswords) return
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      const cambioContrasinal = true
      const payload = {
        userDetails: {
          email: this.$store.state.AppActiveUser.username,
          password: this.oldPassword,
          cambioContrasinal
        }
      }
      this.$store.dispatch('auth/login', payload)
        .then(() => { 
          this.cambiarContrasinal()
        })
        .catch(error => {
          this.showChangePasswordError(error)
        })
    },
    cambiarContrasinal () {
      delete this.usuario.username
      delete this.usuario.roles
      delete this.usuario.nombre
      delete this.usuario.apellidos
      delete this.usuario.dni
      delete this.usuario.email
      delete this.usuario.empresa
      this.usuario.password = this.newPassword1
      this.$store.dispatch('userManagement/updateUser', this.usuario)
        .then((response)   => { 
          this.usuario = response.data
          this.showChangePasswordSuccess() 
        })
        .catch(error => { 
          this.showChangePasswordError(error) 
        })
    },
    showChangePasswordSuccess () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'CONTRASEÑA MODIFICADA',
        text: 'La contraseña ha sido modificada correctamente.'
      })
      this.popupCambioContrasinal = false
    },
    showChangePasswordError (error) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'ERROR',
        text:  error
      })
    },
    cerrarPopup () {
      this.popupCambioContrasinal = false
      this.oldPassword = ''
      this.newPassword1 = ''
      this.newPassword2 = ''
    },
    cancelar () {
      this.$router.push({name:'inicio'}).catch(() => {})
    }
  },
  created () {
    const userId = this.$route.params.userId
    const usuario = JSON.parse(sessionStorage.getItem('userInfo'))
    // Se o Id de usuario que ven na ruta non é o mesmo que está gardado na sesión non lle mostramos a páxina
    // eslint-disable-next-line no-unused-expressions
    userId != usuario.uid ? this.$router.push({name:'inicio'}).catch(() => {}) : null

    // Register Module UserManagement Module
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
        
    this.$store.dispatch('userManagement/fetchUser', userId)
      .then((response)   => { 
        this.usuario = response.data
        this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      })
      .catch(
        this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      )
  }
}
</script>